<template>
  <SfCounter :id="id" data-testid="id">{{ value }}</SfCounter>
</template>

<script setup lang="ts">
import type { CounterProps } from '~/components/ui/Counter/types';

defineProps<CounterProps>();
</script>
